import { render } from "./CustomDialogComponent.vue?vue&type=template&id=0e3ae0d3&scoped=true&ts=true"
import script from "./CustomDialogComponent.vue?vue&type=script&lang=ts"
export * from "./CustomDialogComponent.vue?vue&type=script&lang=ts"

import "./CustomDialogComponent.vue?vue&type=style&index=0&id=0e3ae0d3&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e3ae0d3"]])

export default __exports__